import {httpRequest} from '../config/axios';
import {getDateFromText} from '../utils/helper';

export async function getPartners(data) {
  const response = await httpRequest.post('partner/get', {
    column: data?.column?.value,
    value: data?.value?.value,
  });
  return {
    rows: response?.data?.data?.rows || [],
  };
}

export async function addPartner(data) {
  const response = await httpRequest.post('partner', data);
  return response?.data?.data?.data?.id;
}

export async function updatePartner(data, oldData) {
  const response = await httpRequest.put('partner', {data, clear_data: {partner_code: oldData?.code}});
  return response?.data?.data;
}

export async function getChannels(data) {
  const response = await httpRequest.post('channel/get', {
    column: data?.column?.value,
    value: data?.value?.value,
  });
  return {
    rows: response?.data?.data?.rows || [],
  };
}

export async function addChannel(data) {
  const response = await httpRequest.post('channel', data);
  return response?.data?.data?.data?.id;
}

export async function updateChannel(data, oldData) {
  const response = await httpRequest.put('channel', {data, clear_data: {channel_code: oldData?.code}});
  return response?.data?.data;
}

export async function getChannelMapStatus(data) {
  const response = await httpRequest.post('channel/status-mapping/get', {
    column: data?.column?.value,
    value: data?.value?.value,
  });
  return {
    rows: response?.data?.data?.rows || [],
  };
}

export async function addChannelMapStatus(data) {
  const response = await httpRequest.post('channel/status-mapping', data);
  return response?.data?.data?.data?.id;
}

export async function updateChannelMapStatus(data, oldData) {
  const response = await httpRequest.put('channel/status-mapping', {data});
  return response?.data?.data;
}

export async function getChannelMapRejectionMsg(data) {
  const response = await httpRequest.post('channel/rejection-msg-mapping/get', {
    column: data?.column?.value,
    value: data?.value?.value,
  });
  return {
    rows: response?.data?.data?.rows || [],
  };
}

export async function addChannelMapRejectionMsg(data) {
  const response = await httpRequest.post('channel/rejection-msg-mapping', data);
  return response?.data?.data?.data?.id;
}

export async function updateChannelMapRejectionMsg(data, oldData) {
  const response = await httpRequest.put('channel/rejection-msg-mapping', {
    data,
    clear_data: {
      partner_code: oldData?.partner_code,
      channel_code: oldData?.channel_code,
      partner_rejection_code: oldData?.partner_rejection_code,
    },
  });
  return response?.data?.data;
}

export async function getConfigSQL(data) {
  const response = await httpRequest.post('get-config-sql', {
    column: data?.column?.value,
    value: data?.value?.value,
  });
  return {
    rows: response?.data?.data?.rows || [],
  };
}

export async function addConfigSQL(data) {
  const response = await httpRequest.post('admin/config-operation-sql', {
    operationType: 'ADD',
    ADD: data,
  });
  return response?.data?.data?.data?.id;
}

export async function updateConfigSQL(data) {
  const response = await httpRequest.post('admin/config-operation-sql', {
    operationType: 'UPDATE',
    UPDATE: data,
  });
  return response?.data?.data;
}

export async function getConfigMongo(data) {
  const response = await httpRequest.get(`get-config-mongo?key=${data?.key}`);
  return response?.data?.data?.data || '';
}

export async function refreshConfig(appName) {
  const data = {
    operationType: 'CONFIG_REFRESH',
    appName,
  };
  const response = await httpRequest.post(`admin/refresh-operation`, data);
  return response?.data?.data?.data || '';
}

export async function addOrUpdateConfigMongo(data) {
  const response = await httpRequest.post(`admin/config-operation-mongo`, data);
  return response?.data?.data?.data || '';
}

export async function redisOperation(data) {
  const response = await httpRequest.post(`admin/redis-operation`, data);
  return response?.data?.data || '';
}

export async function getQueues() {
  const response = await httpRequest.get(`get-queues`);
  return {
    rows: response?.data?.data?.rows || [],
  };
}

export async function getCronList(data) {
  const response = await httpRequest.get(`cron?env=${data?.value?.value}`);
  return {
    rows: response?.data?.data?.rows || [],
  };
}

export async function addCron(data) {
  try {
    if (data?.cronHeaders) {
      data.cronHeaders = JSON.parse(data.cronHeaders);
    }
    if (data?.cronBody) {
      data.cronBody = JSON.parse(data.cronBody);
    }
  } catch (error) {
    throw new Error('Invalid JSON format in cronHeaders or cronBody');
  }
  const response = await httpRequest.post(`cron`, data);
  return response?.data?.data?.data?.id;
}

export async function updateCron(data, oldData) {
  try {
    if (data?.cronHeaders) {
      data.cronHeaders = JSON.parse(data.cronHeaders);
    }
    if (data?.cronBody) {
      data.cronBody = JSON.parse(data.cronBody);
    }
  } catch (error) {
    throw new Error('Invalid JSON format in cronHeaders or cronBody');
  }
  const response = await httpRequest.put(`cron`, data);
  return response;
}

export async function getLoggerConfiguration({operationType, appName}) {
  const response = await httpRequest.post(`admin/logger-configuration`, {operationType, appName});
  return response?.data?.data || {};
}

export async function updateLoggerConfiguration(data) {
  const response = await httpRequest.post(`admin/logger-configuration`, data);
  return response?.data?.data || {};
}

export async function fetchAdminOperationHistory() {
  try {
    const date = getDateFromText('Today');
    const response = await httpRequest.post('get-operation-history', {
      date: {
        from: new Date(new Date(date[0]).setFullYear(new Date(date[0]).getFullYear() - 1)).toISOString(),
        to: date[1],
      },
      filters: {
        operationType: ['ADMIN'],
      },
      page: 1,
      sort: {
        field: 'timestamp',
        type: -1,
      },
      limit: 100,
    });
    return {rows: response?.data?.data?.data};
  } catch (error) {
    return error;
  }
}
